import { Image, Link } from "@custom/schema";
import clsx from "clsx";
import React from "react";
import Breadcrumbs from "./Breadcrumbs";
export var BasicHeroSection = function(props) {
    var isFallbackImage = !props.imageFull || !props.imagePortrait;
    return /*#__PURE__*/ React.createElement("div", {
        className: "prose"
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("relative", {
            "h-[10rem] md:h-[18rem]": isFallbackImage,
            "max-h-[17.1875rem] md:max-h-[31.25rem] min-h-[17.1875rem]": !isFallbackImage
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("absolute md:relative left-0 top-0 w-full", {
            "h-[10rem] md:h-[18rem]": isFallbackImage,
            "max-h-[17.1875rem] md:max-h-[31.25rem]": !isFallbackImage
        })
    }, !props.imageFull || !props.imagePortrait ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("img", {
        className: "object-cover w-full h-full hidden md:block",
        src: "/images/fallback-full.png",
        alt: "page hero image"
    }), /*#__PURE__*/ React.createElement("img", {
        className: "object-cover w-full h-full block md:hidden",
        src: "/images/fallback-portrait.png",
        alt: "page hero image"
    })) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Image, {
        className: "object-cover w-full max-h-[31.25rem] hidden md:block",
        source: props.imageFull,
        alt: "page hero image"
    }), /*#__PURE__*/ React.createElement(Image, {
        className: "object-cover w-full max-h-[17.1875rem] block md:hidden",
        source: props.imagePortrait,
        alt: "page hero image"
    })), !isFallbackImage && /*#__PURE__*/ React.createElement("div", {
        className: "absolute bg-gradient-to-b from-black/0 to-black top-[40%] left-0 w-full h-[60%]"
    }), !isFallbackImage ? /*#__PURE__*/ React.createElement("div", {
        className: "absolute container-page left-1/2 -translate-x-1/2 text-white text-center bottom-8 md:bottom-16 w-full"
    }, /*#__PURE__*/ React.createElement("h1", {
        className: "text-3xl leading-4xl md:text-5xl md:leading-6-7xl m-0"
    }, props.title)) : /*#__PURE__*/ React.createElement("div", {
        className: "absolute container-page h-[10rem] md:h-[18rem] w-full left-0 text-white text-center flex bottom-0 items-center justify-center"
    }, !props.hideTitle && /*#__PURE__*/ React.createElement("h1", {
        className: "text-3xl leading-4xl md:text-5xl md:leading-6-7xl m-0"
    }, props.title)))), (props.lead || props.cta || props.breadcrumbs) && /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex"
    }, props.breadcrumbs && /*#__PURE__*/ React.createElement(Breadcrumbs, {
        items: props.breadcrumbs
    })), (props.lead || props.cta) && /*#__PURE__*/ React.createElement("div", {
        className: "container-page items-center justify-center flex flex-col gap-5 prose pb-8 md:pb-10"
    }, props.lead && /*#__PURE__*/ React.createElement("p", {
        className: "md:max-w-[37.5rem] text-center self-center"
    }, props.lead), props.cta && /*#__PURE__*/ React.createElement("div", {
        className: "not-prose"
    }, /*#__PURE__*/ React.createElement(Link, {
        className: "button-primary font-semibold text-sm leading-xs focus-white self-center",
        href: props.cta.url,
        title: props.cta.title
    }, props.cta.title)))));
};
